import React, { Component, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
    InputAdornment, IconButton, TextField, Select, Checkbox,
    Grid, Radio, RadioGroup, FormControlLabel, Input,
    MenuItem
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete'
import classNames from 'classnames';
import Typo from './CustomTypo'
import { formatFloat, parseFloat, parseAPIFloat } from '../utils/formatUtil';
import { CheckIcon, CheckIconPrimary, ArrowDownIcon } from './icons';
import {
    MuiPickersUtilsProvider,
    DatePicker,
    KeyboardDatePicker
} from '@material-ui/pickers';
import moment from "moment";
import MomentUtils from "@date-io/moment";
import t from '../utils/translateUtil'
import { spacing } from '@material-ui/system';

const styles = theme => ({
    root: {
        flexGrow: 1,
        width: '100%',
    },
    padding: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    customPadding: {
        // ...theme.customTypo.inputField,
        paddingTop: theme.spacing(2) / 2,
        paddingBottom: theme.spacing(2) / 4,
    },
    inputRoot: {
        border: '1px solid',
        borderColor: theme.palette.border.secondary,
        borderRadius: 24,
        height: 48,
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.background.secondary,
        paddingLeft: theme.spacing(6),
        paddingRight: theme.spacing(6),
        marginTop: theme.spacing(1),
        position: 'relative'
    },
    inputRootAutocomplete: {
        border: '1px solid',
        borderColor: theme.palette.border.secondary,
        borderRadius: 24,
        height: 48,
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.background.secondary,
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        marginTop: theme.spacing(1),
        position: 'relative',
    },
    inputRootLarge: {
        //...theme.customTypo.headline,
        borderBottom: '1px solid',
        borderBottomColor: theme.palette.border.primary,
        marginTop: theme.spacing(1),
        height: 48,
        backgroundColor: theme.palette.background.transparent,
        paddingLeft: theme.spacing(6),
        paddingRight: theme.spacing(2) + theme.spacing(2) / 2,
        position: 'relative'
    },
    inputDisable: {
        ...theme.palette.button.disabled
        //backgroundColor: theme.palette.border.primary,
        //color:theme.palette.input.label,
    },
    inputArea: {
        border: '1px solid',
        borderColor: theme.palette.border.secondary,
        borderRadius: 24,
        minHeight: theme.spacing(24),
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.background.secondary,
        paddingLeft: theme.spacing(6),
        paddingRight: theme.spacing(6),
        marginTop: theme.spacing(1),
        position: 'relative'
    },
    blur: {
        border: '1px solid',
        borderColor: theme.palette.border.primary,
        backgroundColor: theme.palette.background.blur,
        color: theme.palette.text.onPrimary,
        '&::placeholder': {
            color: theme.palette.text.blur,
        },
    },
    onPrimary: {
        color: theme.palette.input.label,
        backgroundColor: theme.palette.background.secondary,
    },
    primary: {
        color: theme.palette.input.secondary,
    },
    leftIconStyle: {
        width: 24,
        height: 24
    },
    selectIcon: {
        paddingRight: theme.spacing(2) + theme.spacing(2) / 2,
    },
    leftIconPadding: {
        paddingRight: 0,
        paddingLeft: 0,
    },
    inputLine: {
        width: '100%',
        // marginTop: theme.spacing(2),
    },
    inputSelectRoot: {
        width: '100%',
        marginLeft: theme.spacing(2),
        marginTop: theme.spacing(2),
    },
    textSelect: {
        marginTop: theme.spacing(2.8),
    },
    checkBoxField: {
        paddingTop: 0,
        paddingRight: theme.spacing(2),
        paddingBottom: 0,
        paddingLeft: 0,
    },
    selectClass: {
        width: '100%',
        border: '1px solid',
        borderColor: theme.palette.border.primary,
        borderRadius: 16,
        paddingLeft: theme.spacing(6),
        paddingRight: theme.spacing(2) + theme.spacing(2) / 2,
        height: 48,
        '&:before': {
            content: 'unset',
        },
        '&:after': {
            borderBottom: 'none',
        },
        '&:active': {
            border: 'none'
        }
    },
    border: {
        border: 'none',
        backgroundColor: 'red!important'
    },
    bgColor: {
        backgroundColor: theme.palette.background.info_light,
        borderColor: 'transparent',
    },
    menuItem: {
        paddingBottom: theme.spacing(4),
        paddingTop: theme.spacing(4),
    },
    selectCustom: {
        padding: "10px 0 6px 0"
    },
    selectCustomIcon: {
        marginTop: theme.spacing(2),
    },
    selectCustomRoot: {
        marginRight: theme.spacing(4),
        width: '60'
    },
    selectCustomW: {
        width: '100%',
        marginLeft: theme.spacing(2)
    },
    position: {
        position: 'absolute',
        top: theme.spacing(3)
    },
    listBox: {
        width: '300px!important',
    },
    paddingRight:{
        paddingRight: theme.spacing(2) ,
    }
    
});

function TextFieldCustom({
    input: { name, onChange, value, inputlabelprops, type, multiline, ...restInput },
    label, color, isEdit, placeholder, dataType, formatType,
    meta, inputCss, leftIcon, leftIconAction, leftIconColor, leftIconActionDisabled, endAdornment,
    onCustomChange, maxLength, startPrefix, large, disableEndAdornment, rightLabelComponent, isValueNull, valuez,customLabel, 
    ...rest
}) {
    if (!color)
        color = 'label';
    let fieldFormat = rest.fieldFormat;
    let fieldParse = rest.fieldParse;
    let fieldParseOnBlur = rest.fieldParseOnBlur;
    if (formatType === 'float') {
        fieldFormat = formatFloat;
        fieldParse = parseFloat;
        fieldParseOnBlur = parseAPIFloat;
    }
    if(valuez){
        onChange(valuez);
    }

    let _onChange = event => {
        if (onCustomChange) {
            onCustomChange(event.target.value);
        }
        if (rest && fieldFormat == formatFloat && fieldParse == parseFloat) {
            event.persist();
            const caretStart = event.target.selectionStart;
            let value = event.target.value;
            let parsedValue = fieldParse ? fieldParse(event.target.value) : value;
            let formatedValue = parsedValue;
            if (fieldFormat) {
                formatedValue = fieldFormat(formatedValue);
            }
            let newCaretStart = caretStart + formatedValue.length - value.length;
            // if (newCaretStart == caretStart && caretStart >0)
            //     newCaretStart = newCaretStart + 1;
            //console.log(value, parsedValue);
            //console.log('111111111111', caretStart, formatedValue.length, value.length, newCaretStart)
            onChange(parsedValue);
            window.requestAnimationFrame(() => {
                event.target.selectionStart = newCaretStart
                event.target.selectionEnd = newCaretStart
            })
        } else {
            if (fieldParse)
                onChange(fieldParse(event.target.value));
            else
                onChange(event);
        }

    }
    let _onBlur = event => {
        let trimmedVal = value;
        if (value)
            trimmedVal = value.toString().trim();
        if (fieldParseOnBlur) {
            onChange(fieldParseOnBlur(trimmedVal))
        } else
            onChange(trimmedVal);
    }
    let formattedValue = fieldFormat ? fieldFormat(value) : value;

    return (
        <Grid xs={12} sm={12} item className={rest.classes.padding}>
            {customLabel ? (label ? label : null) : <Grid xs={12} sm={12} item container>
                <Grid xs={8} sm={8} item>
                    {label && <Typo mg_left_md variant="input_label" color={color}>{label}</Typo>}
                </Grid>
                <Grid xs={4} sm={4} item container justify="flex-end" className={rest.classes.paddingRight}>
                    {rightLabelComponent}
                </Grid>
            </Grid>}
            {/* {isEdit ? */}
            <TextField
                className={rest.classes.inputLine}
                name={name}
                type={type}
                helperText={meta.touched ? meta.error : undefined}
                error={meta.error && meta.touched}
                placeholder={placeholder}
                onChange={_onChange}
                value={isValueNull ? '' : (valuez ? valuez: formattedValue)}
                onBlur={_onBlur}
                InputProps={{
                    readOnly: !isEdit,
                    disableUnderline: true,
                    classes: { root: color ? classNames(large ? rest.classes.inputRootLarge : rest.classes.inputRoot, rest.classes[color], !isEdit ? rest.classes.inputDisable : undefined) : rest.classes.inputRoot },
                    endAdornment: endAdornment ? <InputAdornment position="end" >
                                                    {endAdornment}
                                                </InputAdornment>: 
                                                (!value || !meta.valid || disableEndAdornment ? 
                                                undefined : <InputAdornment position="end" >
                                                <CheckIcon className={rest.classes.leftIconStyle} />
                                            </InputAdornment>) 
                        ,
                    startAdornment:
                        !startPrefix ? undefined : (
                            <InputAdornment position="start">
                                <Typo type={large ? "headline" : "inputField"} color={color} >{startPrefix}</Typo>
                            </InputAdornment>)

                }}
            />
        </Grid>

    )
}
function TextAreaCustom({
    input: { name, onChange, value, inputlabelprops, color, large, ...restInput },
    label, labelColor, isEdit, placeholder,
    meta,
    ...rest
}) {
    return (
        <Grid xs={12} item>
            {label && <Typo type="inputTitle" color={labelColor} >{label}</Typo>}
            {isEdit ?
                <TextField
                    className={rest.classes.inputLine}
                    type="textarea"
                    name={name}
                    multiline
                    rows={3}
                    helperText={meta.touched ? meta.error : undefined}
                    error={meta.error && meta.touched}
                    placeholder={placeholder}
                    onChange={onChange}
                    value={value}
                    InputProps={{
                        readOnly: !isEdit,
                        disableUnderline: true,
                        classes: { root: color ? classNames(large ? rest.classes.inputRootLarge : rest.classes.inputArea, rest.classes[color], !isEdit ? rest.classes.inputDisable : undefined) : rest.classes.inputArea },
                    }}
                /> : <Typo type="inputField" >{value ? value : '_'}</Typo>}
        </Grid>

    )
}

const StyledCheckbox = withStyles((theme) => ({
    root: {
        color: theme.palette.primary.light,
        '&$checked': {
            color: theme.palette.primary.light
        },
    },
    checked: {}

}))(Checkbox);

function CheckBoxCustom({
    input: { name, onChange, value, checked, inputlabelprops, ...restInput },
    meta, label, isEdit, isChecked, isNotShowError, values, disableCss, lableCSS, customLabel, alignItems,
    ...rest
}) {
    return (
        <Grid xs={12} item container direction="row">
            <Grid xs={12} item container direction="row" alignItems={alignItems ? alignItems : 'center'}>
                <StyledCheckbox
                    className={classNames(rest.classes.checkBoxField)}
                    checked={checked}
                    onChange={onChange}
                    value={value}
                />
                {label ? <Typo type="description" color='onPrimary'>{label}</Typo> : undefined}
                {customLabel ? customLabel : undefined}
            </Grid>
            {meta.touched &&
                <Typo type="warning" color='error' >{meta.error}</Typo>
            }
        </Grid>
    )
}
function DatePickerCustom({ input: { name, onChange, value, inputlabelprops, ...restInput },valuez, onCustomChange,
    meta, label, isEdit, color, dataType, ...rest }) {
    const [formattedValue, setFormattedValue] = useState("");
    return (
        <Grid xs={12} item className={rest.classes.padding}>
            {label && <Typo mg_left_md variant="input_label" color={color} >{label}</Typo>}
            <MuiPickersUtilsProvider utils={MomentUtils}>
                <DatePicker
                    //format="DD/MM"
                    //value={value}
                    disabled={!isEdit}
                    onChange={date => {
                        onChange(date);
                        setFormattedValue(date.format("DD/MM/YYYY"));
                        if(onCustomChange) onCustomChange(date);
                    }}
                    name={name}         
                    autoOk
                    placeholder="DD/MM/YYYY"
                    mask={value =>
                        value
                            ? [/\d/, /\d/, ".", /\d/, /\d/, ".", /\d/, /\d/, /\d/, /\d/]
                            : []
                    }
                    TextFieldComponent={props => (
                        <TextField
                            {...props}
                            value={formattedValue ? formattedValue : valuez }
                            onInputChange={event => setFormattedValue(event.target.value)}
                            className={rest.classes.inputLine}
                            placeholder={"DD/MM/YYYY"}
                            inputProps={rest.classes.customPadding}
                            InputProps={{
                                disableUnderline: true,
                                classes: { root: color ? classNames(rest.classes.inputRoot, rest.classes[color]) : rest.classes.inputRoot },
                            }}
                            helperText={meta.touched ? meta.error : undefined}
                            error={meta.error && meta.touched}
                        />
                    )}
                />
            </MuiPickersUtilsProvider>
        </Grid>
    );
}

function SelectCustomMoreInfo({ input: { name, onChange, value, inputlabelprops, onBlur, ...restInput },
    meta, label, isEdit, labelColor, onCustomChange, placeholder, defaultvalue, hidePlaceholder, t, clearable, bgColor, displayAttr, valueAttr, ...rest }) {
    // value = defaultvalue;
    var data = rest.data ? rest.data : [];
    let color = labelColor ? labelColor : 'default';
    if (clearable)
        value = "";
    return (
        <Grid xs={12} item className={rest.classes.padding}>
            {label && <Typo type="inputTitle" color={color} >{label}</Typo>}
            <Select className={classNames(rest.classes.selectClass, rest.classes.inputLine, bgColor ? rest.classes.bgColor : null)}
                IconComponent={(props) => {
                    if (isEdit)
                        return (
                            <i {...props}
                                className={classNames(`material-icons ${props.className}`,
                                    rest.classes.leftIconStyle, rest.classes.selectIcon)}>keyboard_arrow_down
                            </i>
                        )
                    else
                        return null;
                }}
                name={name}
                disabled={!isEdit}
                classes={{ disabled: rest.classes.disabled, root: rest.classes.disabled }}
                onChange={e => {
                    onChange(e);
                    if (onCustomChange)
                        onCustomChange(e)
                }}
                input={<Input name={name} id={name} />}
                value={value}
                // defaultValue={defaultvalue}
                displayEmpty
                helpertext={meta.touched ? meta.error : undefined}
                inputProps={{ className: classNames(rest.classes.customPadding) }}
                disableUnderline={!isEdit}
            >
                {hidePlaceholder ? "" : <MenuItem value="">
                    <Typo type='placeholder'>{placeholder ? placeholder : t("Please Select")}</Typo>
                </MenuItem>}
                {data && Array.isArray(data) && data.map((option, index) => (
                    <MenuItem key={index} value={displayAttr ? option[valueAttr] : option.id} className={rest.classes.menuItem}>
                        <Grid xs={12} item container direction='row'>
                            <Grid xs={3} item container justify="center" alignContent='center'>
                                {option.displayIcon}
                            </Grid>
                            <Grid xs={9} item container >
                                <Grid xs={12} item >
                                    <Typo type='placeholder' style={{ marginLeft: 8 }}>{displayAttr ? option[displayAttr] : t(option.name)}</Typo>
                                </Grid>
                                <Grid xs={12} item >
                                    <Typo type='description' style={{ marginLeft: 8 }}>{option.more_info}</Typo>
                                </Grid>
                            </Grid>
                        </Grid>
                    </MenuItem>
                ))}
            </Select>
            {meta.touched && <Typo type="description" color='error' >{meta.error}</Typo>}
        </Grid>
    );
}

function TextFieldWithSelect({
    input: { name, onChange, value, inputlabelprops, type, ...restInput },
    label, color, isEdit, placeholder, dataType, formatType,
    meta, inputCss, leftIcon, leftIconAction, leftIconColor, leftIconActionDisabled, selectData, defaultValueSelect, valueSelect,
    onCustomChange, maxLength, startPrefix, large, disableEndAdornment, rightLabelComponent, onSelectedChange,
    ...rest
}) {
    if (!color)
        color = 'label';
    let fieldFormat = rest.fieldFormat;
    let fieldParse = rest.fieldParse;
    let fieldParseOnBlur = rest.fieldParseOnBlur;
    if (formatType === 'float') {
        fieldFormat = formatFloat;
        fieldParse = parseFloat;
        fieldParseOnBlur = parseAPIFloat;
    }
    let _onChange = event => {
        if (onCustomChange) {
            onCustomChange();
        }
        if (rest && fieldFormat == formatFloat && fieldParse == parseFloat) {
            event.persist();
            const caretStart = event.target.selectionStart;
            let value = event.target.value;
            let parsedValue = fieldParse ? fieldParse(event.target.value) : value;
            let formatedValue = parsedValue;
            if (fieldFormat) {
                formatedValue = fieldFormat(formatedValue);
            }
            let newCaretStart = caretStart + formatedValue.length - value.length;
            onChange(parsedValue);
            window.requestAnimationFrame(() => {
                event.target.selectionStart = newCaretStart
                event.target.selectionEnd = newCaretStart
            })
        } else {
            if (fieldParse)
                onChange(fieldParse(event.target.value));
            else
                onChange(event);
        }

    }
    let _onBlur = event => {
        let trimmedVal = value;
        if (value)
            trimmedVal = value.toString().trim();
        if (fieldParseOnBlur) {
            onChange(fieldParseOnBlur(trimmedVal))
        } else
            onChange(trimmedVal);
    }
    let formattedValue = fieldFormat ? fieldFormat(value) : value;
    console.log("valueSelect:",valueSelect);
    return (
        <Grid xs={12} sm={12} item className={rest.classes.padding}>
            <Grid xs={12} sm={12} item container>
                <Grid xs={8} sm={8} item>
                    {label && <Typo mg_left_md variant="input_label" color={color}>{label}</Typo>}
                </Grid>
                <Grid xs={4} sm={4} item container justify="flex-end">
                    {rightLabelComponent}
                </Grid>
            </Grid>
            <Grid xs={12} sm={12} item container direction="row">
                <Grid xs={4} item>
                    
                    <Autocomplete
                        id="country-select-demo"
                        options={selectData}
                        classes={{
                            option: rest.classes.selectCustomRoot,
                            paper: rest.classes.listBox
                        }}
                        onChange={(event, newValue) => onSelectedChange(newValue)}
                        //onInputChange={onSelectedChange}
                        autoHighlight
                        closeIcon={null}
                        getOptionLabel={(option) => option.label}
                        renderOption={(option) => {
                            var SelectIcon = option.icon;
                            return (
                                <React.Fragment>
                                    {<SelectIcon />}
                                    <Typo mg_left_sm>{option.label} +{option.phone_code}</Typo>
                                </React.Fragment>
                            )
                        }

                        }
                        renderInput={(params) => {
                            console.log("params:", params);
                            if (!params.inputProps.value){
                                params.inputProps.value = valueSelect?valueSelect.label : 'Cyprus'
                            }
                            let FlagSelected = valueSelect ? valueSelect.icon : undefined
                            return (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    inputProps={{
                                        ...params.inputProps,
                                        className: { width: 100 },
                                        autoComplete: 'new-password', // disable autocomplete and autofill
                                    }}
                                    InputProps={{
                                        ...params.InputProps,
                                        fullWidth: true,
                                        className: rest.classes.inputRootAutocomplete,
                                        startAdornment: <div style={{marginRight:4}}><FlagSelected/></div>
                                    }}
                                />
                            )
                        }}
                    />
                </Grid>
                <Grid xs={8} item style={{ paddingLeft: 8 }}>
                    <Grid xs={12} item container direction="row" className={color ? classNames(rest.classes.inputRoot, rest.classes[color]) : rest.classes.inputRoot}>
                        <Grid xs={2} sm={2} item container justify='flex-end' className={rest.classes.textSelect}>
                            <Typo variant="subtitle2">{valueSelect && valueSelect.phone_code ? '+' + valueSelect.phone_code : ''}</Typo>
                        </Grid>
                        <Grid xs={10} sm={10} item>
                            <TextField
                                className={rest.classes.inputSelectRoot}
                                name={name}
                                type={type}
                                helperText={meta.touched ? meta.error : undefined}
                                error={meta.error && meta.touched}
                                placeholder={placeholder}
                                onChange={_onChange}
                                value={formattedValue}
                                onBlur={_onBlur}
                                InputProps={{
                                    readOnly: !isEdit,
                                    disableUnderline: true,
                                    endAdornment: !value || !meta.valid || disableEndAdornment ? undefined :
                                        (<InputAdornment position="end" >
                                            <CheckIcon className={rest.classes.leftIconStyle} />
                                        </InputAdornment>),
                                    startAdornment:
                                        !startPrefix ? undefined : (
                                            <InputAdornment position="start">
                                                <Typo type={large ? "headline" : "inputField"} color={color} >{startPrefix}</Typo>
                                            </InputAdornment>)

                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>

        // <Grid xs={12} sm={12} item className={rest.classes.padding}>
        //     <Grid xs={12} sm={12} item container>
        //         <Grid xs={8} sm={8} item>
        //             {label && <Typo mg_left_md variant="input_label" color={color}>{label}</Typo>}
        //         </Grid>
        //         <Grid xs={4} sm={4} item container justify="flex-end">
        //             {rightLabelComponent}
        //         </Grid>
        //     </Grid>
        //     <Grid xs={12} sm={12} item container direction="row" justify='flex-end' className={color ? classNames(large ? rest.classes.inputRootLarge : rest.classes.inputRoot, rest.classes[color]) : rest.classes.inputRoot}>
        //         <Grid xs={2} item>
        //             {selectData && <Select
        //                 className={rest.classes.selectCustomRoot}
        //                 disableUnderline
        //                 defaultValue={defaultValueSelect}
        //                 value={valueSelect}
        //                 onChange={onSelectedChange}
        //                 IconComponent={ArrowDownIcon}
        //                 classes={{ select: rest.classes.selectCustom, icon: rest.classes.selectCustomIcon }}
        //             >
        //                 {selectData.map((item, index) => {
        //                     var SelectIcon = item.icon;
        //                     return <MenuItem value={item}><SelectIcon /></MenuItem>
        //                 })}
        //             </Select>}
        //         </Grid>
        //         <Grid xs={2} sm={1} item container justify='flex-end' className={rest.classes.textSelect}>
        //             <Typo variant="subtitle2">{valueSelect.phone_code ? '+'+valueSelect.phone_code:''}</Typo>
        //             </Grid>  
        //         <Grid xs={8} sm={9} item>
        //         <TextField
        //             className={rest.classes.inputSelectRoot}
        //             name={name}
        //             type={type}
        //             helperText={meta.touched ? meta.error : undefined}
        //             error={meta.error && meta.touched}
        //             placeholder={placeholder}
        //             onChange={_onChange}
        //             value={formattedValue}
        //             onBlur={_onBlur}
        //             InputProps={{
        //                 readOnly: !isEdit,
        //                 disableUnderline: true,
        //                 endAdornment: !value || !meta.valid || disableEndAdornment ? undefined :
        //                     (<InputAdornment position="end" >
        //                         <CheckIcon className={rest.classes.leftIconStyle} />
        //                     </InputAdornment>),
        //                 startAdornment:
        //                     !startPrefix ? undefined : (
        //                         <InputAdornment position="start">
        //                             <Typo type={large ? "headline" : "inputField"} color={color} >{startPrefix}</Typo>
        //                         </InputAdornment>)

        //             }}
        //         />
        //         </Grid>

        //     </Grid>
        // </Grid>

    )
}
function SelectCustom({
    input: { name, onChange, value, inputlabelprops, type, ...restInput },
    label, color, placeholder, dataType,
    meta, inputCss, leftIcon, leftIconAction, leftIconColor, leftIconActionDisabled, selectData, defaultValueSelect, valueSelect,
    onCustomChange, maxLength, startPrefix, large, disableEndAdornment, rightLabelComponent, onSelectedChange, isEdit, onOpenCustom,
    ...rest
}) {
    //console.log(' SelectCustom =valueSelect===', valueSelect)
    //console.log(' SelectCustom =isEdit===', isEdit)

    return (
        <Grid xs={12} sm={12} item className={rest.classes.padding}>
            <Grid xs={12} sm={12} item container>
                <Grid xs={6} sm={6} item>
                    {label && <Typo mg_left_md variant="input_label" color={color}>{label}</Typo>}
                </Grid>
                <Grid xs={6} sm={6} item container justify="flex-end">
                    {rightLabelComponent}
                </Grid>
            </Grid>
            <Grid xs={12} sm={12} item container direction="row" alignItems='center' className={color ? classNames(large ? rest.classes.inputRootLarge : rest.classes.inputRoot, rest.classes[color], !isEdit ? rest.classes.inputDisable : undefined) : rest.classes.inputRoot}>
                {!valueSelect && <Grid xs={10} item className={rest.classes.position}><Typo >{placeholder ? placeholder : t("Please Select")}</Typo></Grid>}
                {selectData && <Select
                    className={rest.classes.selectCustomW}
                    disableUnderline
                    defaultValue={defaultValueSelect}
                    value={valueSelect}
                    onChange={e => {
                        onChange(e);
                        if (onSelectedChange)
                            onSelectedChange(e)
                    }}
                    IconComponent={ArrowDownIcon}
                    displayEmpty={true}
                    disabled={!isEdit}
                    classes={{ select: rest.classes.selectCustom, icon: rest.classes.selectCustomIcon }}
                    onOpen={onOpenCustom ? onOpenCustom : null}
                >

                    {selectData.map((item, index) => {
                        var SelectIcon = item.icon;
                        return (<MenuItem key={index} value={item.value}>
                            <Grid xs={12} item container>
                                {item.icon && <SelectIcon />}
                                {isEdit ? <Typo mg_left_md>{item.label}</Typo> : <Typo mg_left_md color='label'>{item.label}</Typo>}
                            </Grid>
                        </MenuItem>)
                    })}
                </Select>}
                {meta.touched && <Typo type="warning" color='error' >{meta.error}</Typo>}
            </Grid>
        </Grid>

    )
}
function Select2Custom({
    input: { name, onChange, value, inputlabelprops, type, ...restInput },
    label, color, placeholder, dataType,
    meta, inputCss, leftIcon, leftIconAction, leftIconColor, leftIconActionDisabled, selectData, selectData2, defaultValueSelect, valueSelect, valueSelect2,
    onCustomChange, maxLength, startPrefix, large, disableEndAdornment, rightLabelComponent, onSelectedChange, onSelectedChange2,
    ...rest
}) {


    return (
        <Grid xs={12} sm={12} item className={rest.classes.padding}>
            <Grid xs={12} sm={12} item container>
                <Grid xs={6} sm={6} item>
                    {label && <Typo mg_left_md variant="input_label" color={color}>{label}</Typo>}
                </Grid>
                <Grid xs={6} sm={6} item container justify="flex-end">
                    {rightLabelComponent}
                </Grid>
            </Grid>
            <Grid xs={12} sm={12} item container direction="row" alignItems='center' className={color ? classNames(large ? rest.classes.inputRootLarge : rest.classes.inputRoot, rest.classes[color]) : rest.classes.inputRoot}>

                <Grid xs={2} sm={2} item>
                    {selectData && <Select
                        className={rest.classes.selectCustomRoot}
                        disableUnderline
                        defaultValue={defaultValueSelect}
                        value={valueSelect}
                        onChange={onSelectedChange}
                        IconComponent={ArrowDownIcon}
                        displayEmpty={true}
                        classes={{ select: rest.classes.selectCustom, icon: rest.classes.selectCustomIcon }}
                    >

                        {selectData.map((item, index) => {
                            var SelectIcon = item.icon;
                            return <MenuItem value={index + 1}>
                                <Grid xs={12} item container>
                                    {item.icon && <SelectIcon />}
                                    <Typo >{item}</Typo>
                                </Grid>
                            </MenuItem>
                        })}
                    </Select>}
                </Grid>
                <Grid xs={10} sm={10} item >
                    {!valueSelect && !valueSelect2 && <Grid xs={10} item className={rest.classes.position}><Typo mg_left_xs>{placeholder ? placeholder : t("Please Select")}</Typo></Grid>}
                    {selectData2 && <Select
                        className={rest.classes.selectCustomW}
                        disableUnderline
                        defaultValue={defaultValueSelect}
                        value={valueSelect2}
                        onChange={onSelectedChange2}
                        IconComponent={ArrowDownIcon}
                        displayEmpty={true}
                        classes={{ select: rest.classes.selectCustom, icon: rest.classes.selectCustomIcon }}
                    >

                        {selectData2.map((item, index) => {
                            var SelectIcon = item.icon;
                            return <MenuItem value={index + 1}>
                                <Grid xs={12} item container>
                                    {item.icon && <SelectIcon />}
                                    <Typo>{item}</Typo>
                                </Grid>
                            </MenuItem>
                        })}
                    </Select>}
                </Grid>
            </Grid>
        </Grid>

    )
}
const TextFieldComponent = withStyles(styles)(TextFieldCustom);
const CheckBoxComponent = withStyles(styles)(CheckBoxCustom);
const DatePickerComponent = withStyles(styles)(DatePickerCustom);
const SelectComponent = withStyles(styles)(SelectCustom);
const Select2Component = withStyles(styles)(Select2Custom);
const SelectComponentMoreInfo = withStyles(styles)(SelectCustomMoreInfo);
const TextFieldWithSelectComponent = withStyles(styles)(TextFieldWithSelect);
const TextAreaComponent = withStyles(styles)(TextAreaCustom);
export {
    TextFieldComponent,
    CheckBoxComponent,
    DatePickerComponent,
    SelectComponent,
    Select2Component,
    SelectComponentMoreInfo,
    TextFieldWithSelectComponent,
    TextAreaComponent
};